import styled from 'styled-components';
import MediaManagerGalleryMode from './GalleryMode';
import MediaManagerListMode  from './ListMode';
import { useMediaExplorer } from 'modules/media/services/hooks/useMediaExplorer';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import MediaManagerGridMode from './GridMode';
import useViewMode from 'modules/media/services/hooks/useViewMode';
import { useMediaQuery } from 'react-responsive';
import MediaMobile from '../MediaMobile';

const MediaLibraryListPage = () => {
  const [data, mutate] = useGetManageLibrary();
  const { mode: viewMode, setViewMode } = useViewMode();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const {
    items,
    pathStack,
    openFolder,
    onBack,
    currentPath,
  } = useMediaExplorer(data, mutate);

  if (isMobile) {
    return (
      <MediaMobile />
    );
  }
  
  return (
    <Container>
      <MediaManagerGalleryMode viewMode={viewMode} onChangeViewMode={setViewMode} path={pathStack} onBack={onBack} currentPath={currentPath} onSuccess={mutate} />
      {viewMode === 'list' ? (
        <MediaManagerListMode items={items} onOpenFolder={openFolder} currentPath={currentPath} onSuccess={mutate} />
      ) : (
        <MediaManagerGridMode items={items} onOpenFolder={openFolder} currentPath={currentPath} onSuccess={mutate}/>
      )}
    </Container>
  );
};

export default MediaLibraryListPage;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;